export default {
  autoUpdate: 'Update automatically',
  updateInterval: 'Update interval',
  lastUpdate: 'Last update',
  nextUpdate: 'Next update in {0}',
};
